<template>
  <a :href="href" class="cta-button" :target="target">{{buttonText}}</a>
</template>
<script>
export default {
  name: 'CTA',
  props: {
    href: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
.cta-button {
  display: inline-block;
  background: $blue;
  color: $white;
  padding: 16px 24px;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,.07);
  }
  &:active {
    color: #2c7899;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CTA.vue